var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("static-loading-indicator-icon", { attrs: { "with-card": true } }),
      _vm._v(" "),
      !_vm.$store.getters.isExecutingRequest
        ? _c("div", [
            _vm.errorOccured
              ? _c("div", { staticClass: "card shadow-sm" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-8" }, [
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "pages.subscription.status_subscription_error"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            on: { click: _vm.getSubscriptionStatus }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "pages.subscription.status_button_reload"
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm._m(0)
                    ])
                  ])
                ])
              : _c("div", [
                  !_vm.isSubscribed && _vm.status !== "past_due"
                    ? _c("div", { staticClass: "card shadow-sm" }, [
                        _c("div", { staticClass: "card-body" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-md-8" }, [
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "pages.subscription.status_not_subscribed"
                                    )
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("pages.subscription.subscribe_now")
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  on: {
                                    click: function($event) {
                                      return _vm.$router.push({
                                        name: "start-subscription"
                                      })
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "pages.subscription.start_subscription_button"
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _vm._m(1)
                          ])
                        ])
                      ])
                    : _vm.isSubscribed &&
                      _vm.status &&
                      _vm.status !== "canceled"
                    ? _c("div", [
                        _c("div", { staticClass: "card shadow-sm" }, [
                          _c("div", { staticClass: "card-body" }, [
                            _c("h4", { staticClass: "card-title mb-3" }, [
                              _vm._v(_vm._s(_vm.$t("pages.subscription.title")))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-md-10" }, [
                                !_vm.onGracePeriod
                                  ? _c("div", [
                                      _c("p", {
                                        staticClass: "mb-0",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "pages.subscription.status_subscribed"
                                            )
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "pages.subscription.will_be_renewed",
                                              {
                                                price: _vm.renewalPrice,
                                                date: _vm
                                                  .$date(_vm.willBeRenewedAt)
                                                  .format("DD.MM.YYYY")
                                              }
                                            )
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.monthsPaid <
                                        _vm.monthsRequiredForDowngrade &&
                                      _vm.monthsPaid > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "alert alert-secondary border-dark rounded"
                                            },
                                            [
                                              _c("p", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t(
                                                      "pages.subscription.time_until_downgrade"
                                                    )
                                                  )
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "progress",
                                                  staticStyle: {
                                                    height: "30px"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "progress-bar bg-primary progress-bar-striped progress-bar-animated",
                                                      style:
                                                        "width: " +
                                                        _vm.percentageOfMonthsForDowngrade +
                                                        "%",
                                                      attrs: {
                                                        role: "progressbar",
                                                        "aria-valuenow":
                                                          _vm.percentageOfMonthsForDowngrade,
                                                        "aria-valuemin": "0",
                                                        "aria-valuemax": "100"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.monthsPaid
                                                          ) +
                                                          " / " +
                                                          _vm._s(
                                                            _vm.monthsRequiredForDowngrade
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "pages.subscription.months"
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm.monthsPaid >=
                                          _vm.monthsRequiredForDowngrade
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "alert alert-secondary border-dark rounded pb-0"
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "mdi mdi-emoticon-happy-outline mdi-48px text-primary"
                                              }),
                                              _vm._v(" "),
                                              _c("p", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t(
                                                      "pages.subscription.downgraded_info"
                                                    )
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "mt-5" }, [
                                        _c("hr"),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "text-muted cursor-pointer font-weight-light",
                                            on: {
                                              click: function($event) {
                                                return _vm.$router.push({
                                                  name: "cancel-subscription"
                                                })
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "pages.subscription.cancel_subscription"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "text-muted cursor-pointer font-weight-light ml-5",
                                            on: {
                                              click: function($event) {
                                                return _vm.$router.push({
                                                  name: "update-subscription"
                                                })
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "pages.subscription.error.update"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  : _vm.onGracePeriod
                                  ? _c("div", [
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "pages.subscription.is_canceled",
                                              {
                                                date: _vm
                                                  .$date(this.willBeRenewedAt)
                                                  .format("DD.MM.YYYY")
                                              }
                                            )
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-outline-primary mt-4",
                                          on: {
                                            click: function($event) {
                                              return _vm.$router.push({
                                                name: "resume-subscription"
                                              })
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "pages.subscription.resume_subscription"
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-2 text-center" },
                                [
                                  _c("i", {
                                    staticClass:
                                      "mdi mdi-96px mdi-check-decagram",
                                    class: [
                                      _vm.onGracePeriod
                                        ? "text-warning"
                                        : "text-primary"
                                    ]
                                  })
                                ]
                              )
                            ])
                          ])
                        ])
                      ])
                    : !_vm.isSubscribed &&
                      (_vm.status === "past_due" || _vm.status === "incomplete")
                    ? _c("div", [
                        _c("div", { staticClass: "card shadow-sm" }, [
                          _c("div", { staticClass: "card-body" }, [
                            _c("h4", { staticClass: "card-title mb-3" }, [
                              _vm._v(_vm._s(_vm.$t("pages.subscription.title")))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-md-10" }, [
                                _c("div", [
                                  _c("p", {
                                    staticClass: "mb-0",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t(
                                          "pages.subscription.status_subscribed"
                                        )
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.monthsPaid <
                                    _vm.monthsRequiredForDowngrade &&
                                  _vm.monthsPaid > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "alert alert-secondary border-dark rounded"
                                        },
                                        [
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "pages.subscription.time_until_downgrade"
                                                )
                                              )
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "progress",
                                              staticStyle: { height: "30px" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "progress-bar bg-primary progress-bar-striped progress-bar-animated",
                                                  style:
                                                    "width: " +
                                                    _vm.percentageOfMonthsForDowngrade +
                                                    "%",
                                                  attrs: {
                                                    role: "progressbar",
                                                    "aria-valuenow":
                                                      _vm.percentageOfMonthsForDowngrade,
                                                    "aria-valuemin": "0",
                                                    "aria-valuemax": "100"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(_vm.monthsPaid) +
                                                      " / " +
                                                      _vm._s(
                                                        _vm.monthsRequiredForDowngrade
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "pages.subscription.months"
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm.monthsPaid >=
                                      _vm.monthsRequiredForDowngrade
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "alert alert-secondary border-dark rounded pb-0"
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "mdi mdi-emoticon-happy-outline mdi-48px text-primary"
                                          }),
                                          _vm._v(" "),
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "pages.subscription.downgraded_info"
                                                )
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "row align-items-center" },
                                    [
                                      _vm._m(2),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "col" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "pages.subscription.error.text"
                                              )
                                            )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-outline-danger mt-4",
                                      on: {
                                        click: function($event) {
                                          return _vm.$router.push({
                                            name: "update-subscription"
                                          })
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "pages.subscription.error.update"
                                            )
                                          ) +
                                          "\n                  "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mt-5" }, [
                                    _c("hr"),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "text-muted cursor-pointer font-weight-light",
                                        on: {
                                          click: function($event) {
                                            return _vm.$router.push({
                                              name: "cancel-subscription"
                                            })
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "pages.subscription.cancel_subscription"
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-2 text-center" })
                            ])
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.invoices.length
                    ? _c("div", { staticClass: "row mt-4" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "card shadow-sm" }, [
                            _c("div", { staticClass: "card-body" }, [
                              _c("h4", { staticClass: "card-title mb-3" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("pages.subscription.invoices.title")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "table-responsive" }, [
                                _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table table-striped table-borderless"
                                  },
                                  [
                                    _c("thead", [
                                      _c("tr", [
                                        _c("th", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "pages.subscription.invoices.date"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("th", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "pages.subscription.invoices.total"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("th", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "pages.subscription.invoices.status"
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "tbody",
                                      _vm._l(_vm.invoices, function(invoice) {
                                        return _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$date(invoice.date)
                                                  .format("DD.MM.YYYY")
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                parseFloat(invoice.total / 100)
                                                  .toFixed(2)
                                                  .replace(".", ",")
                                              ) + "€"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            invoice.paid
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-success"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                  " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pages.subscription.invoices.status_paid"
                                                          )
                                                        ) +
                                                        "\n                                              "
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-danger"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                  " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pages.subscription.invoices.status_not_paid"
                                                          )
                                                        ) +
                                                        "\n                                              "
                                                    )
                                                  ]
                                                )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "btn btn-outline-dark",
                                                  attrs: {
                                                    href:
                                                      "/subscription/invoice/" +
                                                      invoice.id +
                                                      "/download"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "pages.subscription.invoices.download"
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      }),
                                      0
                                    )
                                  ]
                                )
                              ])
                            ])
                          ])
                        ])
                      ])
                    : _vm._e()
                ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 text-right" }, [
      _c("i", { staticClass: "mdi mdi-48px text-danger mdi-account-question" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 text-right" }, [
      _c("i", { staticClass: "mdi mdi-48px text-danger mdi-account-remove" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-2" }, [
      _c("i", { staticClass: "mdi mdi-96px mdi-alert-decagram text-danger" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }